import { render, staticRenderFns } from "./SportsPicker.vue?vue&type=template&id=35455225&"
import script from "./SportsPicker.vue?vue&type=script&lang=ts&"
export * from "./SportsPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports